export const DEFAULT_AI_TAKEOVER_DELAY_SECONDS = 60;
export const MIN_AI_TAKEOVER_DELAY_SECONDS = 10;
export const MAX_AI_TAKEOVER_DELAY_SECONDS = 600;

// Keep older site rows / in-flight deployments compatible with the default.
export function resolveTakeoverDelay(value: unknown): number {
  return typeof value === "number" && Number.isInteger(value)
    && value >= MIN_AI_TAKEOVER_DELAY_SECONDS && value <= MAX_AI_TAKEOVER_DELAY_SECONDS
    ? value : DEFAULT_AI_TAKEOVER_DELAY_SECONDS;
}

export function formatTakeoverDelay(seconds: number): string {
  const value = resolveTakeoverDelay(seconds);
  return value % 60 === 0 ? `${value / 60} ${value === 60 ? "minute" : "minutes"}` : `${value} seconds`;
}
